function OrganizationSettingsService(ApiService) {
  'ngInject';

  const service = {};

  service.getOrganizationSettings = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/organization_settings.json`, callbackFunc);
  };

  service.toggleOrganizationSettings = function(orgId, data, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/organization_settings.json`, {organization_setting: data}, callbackFunc);
  };
  return service;
}
export default {
  name: 'OrganizationSettingsService',
  fn: OrganizationSettingsService
};